module.exports = __webpack_public_path__ + "img/residual-water.6ccfe6fc.svg";